export default "__VITE_ASSET__5c96fd75__"